let agendamentos = [];

export async function getAgendamentos() {
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/ListaAgendamentos`);
        const data = await response.json();
        if (Array.isArray(data)) {
            agendamentos = [...data];
        } else {
            console.error("A resposta da API não é um array:", data);
            agendamentos = [];
        }
    } catch (error) {
        console.error("Erro na requisição HTTP GET:", error);
        agendamentos = [];
    }
    return agendamentos;
}

export { agendamentos };